export const SET_LOADED = 'bulkExports/SET_LOADED';
export const ADD_EXPORT = 'ADD_EXPORT';
export const UPDATE_EXPORT_PROGRESS = 'reports/UPDATE_EXPORT_PROGRESS';
export const DELETE_EXPORT = 'bulkExports/DELETE_EXPORT';
